import api from "./baseApi.js";
import Vue from 'vue'

export default {

    SendMail(subject, toAddresses, ccAddresses, htmlBody) {

        // console.log("mail with subject", subject, "sent to original", toAddresses, "sent cc original", ccAddresses, "message", htmlBody);

        // users mails where the custom mail sending will be applied
        var email_from = process.env.VUE_APP_MAIL_FROM_TEST.split(',');
        // recipient override
        var email_to = process.env.VUE_APP_MAIL_TO_TEST.split(',');

        let user_email = Vue.prototype.$GAUserAuth.user.username;

        if (email_from.find(x => x == user_email))
            toAddresses = email_to;

        htmlBody = htmlBody.replace(new RegExp('\r?\n', 'g'), '<br>');
        // console.log("mail with subject", subject, "sent to", toAddresses, "sent cc", ccAddresses, "message", htmlBody);

        let email = {
            Subject: subject,
            MailAddresses: toAddresses,
            MailAddressesCC: ccAddresses,
            HtmlBody: htmlBody
        }
        return api.post("Email/SendEmail/", email);
    }
}